import {
  snowflake,
  imageryScores,
  infinity,
  searchData,
  settings,
} from '../../../../assets/images/icons'
export const LhsTree = [
  { title: 'Brand Drivers', imgSrc: snowflake },
  { title: 'Imagery Scores', imgSrc: imageryScores },
  { title: 'Sentiment Split', imgSrc: infinity },
  { title: 'Consumer Engagement Index', imgSrc: settings },
  { title: 'Two Years of Benchmarking Data.', imgSrc: searchData },
]
